import { getAppConfig } from "../../../utils/appConfig";
import useLogin from "./hooks/useLogin";
import BrandingPanel from "./components/BrandingPanel";
import LoginForm from "./components/LoginForm";

const Login = ({ onLoginSuccess }) => {
  const { logo } = getAppConfig();
  const loginProps = useLogin({ onLoginSuccess });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-4xl">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden flex min-h-[560px]">
          <BrandingPanel />
          <LoginForm logo={logo} {...loginProps} />
        </div>
      </div>
    </div>
  );
};

export default Login;
